import corporateRequest from 'utils/corporateRequest'
import studentRequest from 'utils/studentRequest'
import { setViewRoleData } from 'modules/Applied_Roles/actions'
import SuccessMessage from 'utils/SuccessMessage'
import ErrorMessage from 'utils/ErrorMessage'

import authRequest from 'utils/authRequest'
export const setSingleRoleDetails = data => {
  return {
    type: 'SET_SINGLE_ROLE_DETAILS',
    data,
  }
}

export const getSingleRoleDetails =
  (corpID, JobID) => async (dispatch, getState) => {
    const state = getState()
    try {
      const res = await corporateRequest.get(
        `/corporate/role/${JobID}/${state?.auth?.studentId}`
      )
      
      dispatch(setSingleRoleDetails(res?.data?.data))
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }

export const SaveRole = payload => async (dispatch, getState) => {
  const state = getState()

  const data = {
    roleId: payload.id,
    studentId: state?.auth?.studentId,
    isSaved: payload?.isSaved,
  }

  try {
    const result = await studentRequest.post(`/students/role/save`, data)
    if (result?.status >= 200 && result?.status <= 300) {
      let viewRoleCopy = { ...state?.viewRoleDetails?.RoleDetails, ...payload }

      dispatch(setSingleRoleDetails(viewRoleCopy))
      SuccessMessage('Updated Successfully')
    }
    return result
  } catch (error) {
    console.log('Error in Save Role =>', error?.message)
    return error?.response
  }
}

export const ApplyRole = data => async (dispatch, getState) => {
  const state = getState()
  let isCorporateRole = data?.rolePublishedBy !== 'INSTITUTE'

  const payload = {
    roleId: data.role.id,
    studentId: state?.auth?.studentId,
    corporateId: isCorporateRole ? data?.role?.corporate?.id : data?.companyId,
    accessLevel: state?.studentData?.campusDetails?.instituteSubscription?.accessLevel,
    cvUrl: data?.cvUrl || null,
    isSystemResume: data?.isSystemResume || false,
  }

  if(payload.cvUrl === null)
  {
    delete payload.cvUrl
    payload.isSystemResume = true

  } 
  try {
    const result = await studentRequest.post(`/students/role/apply`, payload)
    if (result?.status >= 200 && result?.status <= 300) {
      SuccessMessage('Applied Successfully')
      dispatch(setSingleRoleDetails(data))
    }

    return result
  } catch (error) {
    console.log('Error in publish corporate job role =>', error?.message)
    ErrorMessage(error?.response?.data?.message)
    return error?.response
  }
}
export const getViewRoleData = () => async (dispatch, getState) => {
  const state = getState()
  let viewRoleCopy = state.appliedRoleData?.viewRoleData
  dispatch(setViewRoleData(viewRoleCopy))
}

export const jobSharingEmail = payload => async (dispatch, getState) => {
  const state = getState()
  let id = state?.studentData?.studentDetails?.admin?._id
  try {
    const result = await authRequest.post(`/users/${id}/jobSharing`, payload)
    SuccessMessage('E-mail Send Successfully.')
    return result
  } catch (error) {
    ErrorMessage(error?.message)
  }
}

export const getSingleEligibleRoleDetails =
  (corpID, JobID) => async (dispatch, getState) => {
    const state = getState()
    try {
      const res = await corporateRequest.get(
        `/corporate/eligiblerole/${JobID}/${state?.auth?.studentId}`
      )
      return res?.data?.data
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }


  export const getTPOApprovalRequest=
  (payLoad,JobID) => async (dispatch, getState) => {
    console.log(payLoad)
    const state = getState()

    if(payLoad?.isSystemResume)
    {
      delete payLoad.cvUrl
    }
    try {
      const res = await studentRequest.put(
        `/students/${state?.auth?.studentId}/role/${JobID}/tpoApproval`,payLoad
      )
      return res?.data?.data
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }

  export const getViewedRoleUpdate =
  (JobID) => async (dispatch, getState) => {
    const state = getState()
    let payLoad = {}
    try {
      const res = await studentRequest.put(
        `/students/${state?.auth?.studentId}/viewed/${JobID}`
        ,payLoad
      )
      return res?.data?.data
    } catch (error) {
      console.log('Error in Getting Jobs list', error)
    }
  }